const useBriefZone = () => {
  return {}
}

export default useBriefZone
